import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentSms, faEnvelope } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx';
import React from 'react';
import { Channel } from '@spike/omnichannel-model';
import styles from './ChannelBadge.module.scss';

interface ChannelBadgeProps {
    channel: Channel;
    inverted?: boolean;
    className?: string;
}

export const ChannelBadge: React.FC<ChannelBadgeProps> = ({ channel, inverted, className }) => (
    <span
        className={clsx(
            styles.root,
            channel === 'sms' ? styles.sms : styles.email,
            inverted && styles.inverted,
            className
        )}
    >
        <FontAwesomeIcon icon={channel === 'sms' ? faCommentSms : faEnvelope} />
        {channel === 'sms' ? 'SMS' : 'Email'}
    </span>
);

export default ChannelBadge;
